import BayBadge from '../../BayBadge';
import slugifyText from '../../utilities/slugifyText';

type PlatformType = 'social' | 'client' | 'financial';

interface NavMenuItem {
	id?: string;
	title: string;
	link: string;
	func?: () => void;
	isAccessDenied?: boolean;
}

interface Stage {
	color: string;
	bgValue?: string;
	textValue?: string;
	text: string;
}

interface ConstructedNavItemProps {
	platformType?: PlatformType;
	subItem?: boolean;
	collapsed?: boolean;
	menuItem: NavMenuItem;
	stage?: Stage;
	listing?: unknown;
}

const menuNameAndId = (menuItem: NavMenuItem) => {
	return `${slugifyText(menuItem.id ? menuItem.id : menuItem.title)}_menu_item`;
};

declare const $: any;

const ConstructedNavItem = ({
	platformType,
	subItem,
	collapsed,
	menuItem,
	stage,
	listing,
}: ConstructedNavItemProps) => {
	const menuOnClick = (menuTitle: string, menuFunc?: () => void) => {
		if (platformType && platformType === 'client') {
			/* eslint-disable-next-line no-undef */
			if (typeof $ !== 'undefined') {
				$.logFeature(menuTitle);
			}
		}

		menuFunc && menuFunc();
	};

	return collapsed && !subItem ? (
		<span>
			<a
				className={`nav-link ${menuItem?.isAccessDenied ? 'text-500 text-decoration-none' : ''}`}
				href={menuItem.link}
				id={menuNameAndId(menuItem)}
				onClick={(e) =>
					menuItem?.isAccessDenied
						? e.preventDefault()
						: menuOnClick(e.currentTarget.text, menuItem.func)
				}
			>
				<div className="nav-link--title text-truncate">{menuItem.title}</div>
				{stage && (
					<div className="mx-2 flex-grow">
						<BayBadge
							bg={stage.color}
							bgValue={stage.bgValue}
							className="w-100"
							isLight
							size="md"
							text={stage.color}
							textValue={stage.textValue}
						>
							{stage.text}
						</BayBadge>
					</div>
				)}
			</a>
		</span>
	) : (
		<span>
			<a
				className={`nav-link ${menuItem?.isAccessDenied ? 'text-500 text-decoration-none' : ''}`}
				href={menuItem.link}
				id={menuNameAndId(menuItem)}
				onClick={(e) => menuItem?.isAccessDenied
					? e.preventDefault() : menuOnClick(e.currentTarget.text, menuItem.func)}
			>
				<div className="nav-link--title text-truncate">{menuItem.title}</div>
				{stage && (
					<div className="mx-2 flex-grow">
						<BayBadge
							bg={stage.color}
							bgValue={stage.bgValue}
							className="w-100"
							isLight
							size="md"
							text={stage.color}
							textValue={stage.textValue}
						>
							{stage.text}
						</BayBadge>
					</div>
				)}
			</a>
		</span>
	);
};

export default ConstructedNavItem;
